const build = `module stripe.com/docs/payments

go 1.13

require (
  github.com/stretchr/testify v1.4.0 // indirect
  github.com/stripe/stripe-go v67.5.0+incompatible
  golang.org/x/net v0.0.0-20191119073136-fc4aabc6c914 // indirect
)`;

export default {
  build,
};
